import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Select } from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { Tooltip } from "@gpstrackit/react-controls";
import { IconButton } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
//Actions
import { clearRedux } from 'Redux/actions';
import { toInteger } from "lodash";

const FirmwareList = ({ cameras, messages, onChange, removeItems, loading }) => (
    cameras.length ? cameras.map((item) => {
        if (item?.hardwareVersion === "null") {
            return <></>
        }
        return (
            <CustomCard
                key={`assing-firmware-${item?.deviceModel}-${item?.hardwareVersion}`}
                hideButton
                width={12}
            >
                <div style={{ display: 'grid' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <div>
                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_device_model']}</label><span>{item?.deviceModel}</span>
                            </div>
                            <div>
                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_hardware_version']}</label><span>{item?.hardwareVersion}</span>
                            </div>
                            <div>
                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_devices']}</label><span>{item?.items?.length}</span>
                            </div>
                        </div>
                        <div>
                            <Tooltip title={messages['delete']}>
                                <IconButton style={{ padding: 5 }} onClick={() => {
                                    removeItems(item)
                                }} size="large">
                                    <RemoveCircleIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                    <div style={{ marginTop: 5 }}>
                        <Select
                            id={`firmware-list-${item?.deviceModel}-${item?.hardwareVersion}`}
                            value={item.newFirmware}
                            onChange={(value) => onChange(value, item?.hardwareVersion)}
                            placeholder={messages["assign_firmware_select_firmware"]}
                            options={item.firmwares || []}
                            valueField="version"
                            textField="label"
                            required
                            requiredMessage={messages["required_field"]}
                        />
                    </div>
                    {
                        (item?.firmwares?.length === 0 && !loading) && (
                            <small className="text-danger" style={{ paddingTop: 5 }}>{messages['assign_firmware_no_firmwares']} {item?.hardwareVersion}</small>
                        )
                    }
                </div>
            </CustomCard>
        )
    }) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <label style={{ opacity: 0.5 }}>{messages['assign_firmware_no_data']}</label>
        </div>
    )
);

const StepTwo = (props) => {
    const { messages } = useIntl();
    const { entity, isRestricted, firmwares, assignLastFirmwares, assignBetaFirmwares } = props;
    const dispatch = useDispatch();

    //Redux States
    const {
        allCameras,
        groupingSelectedCameras,
        groupingByHarwareVersion,
        loadingFirmwares
    } = useSelector(state => state.assignFirmwareDeviceRedux);


    const updateFirmware = (items, hardwareVersion, value, key) => {
        const index = items.findIndex(item => item?.hardwareVersion === hardwareVersion);
        if (index > -1) {
            items[index].newFirmware = value;
        }
        dispatch(clearRedux("ASSIGN_FIRMWARE", { [key]: items }));
    };

    const onChange = (value, hardwareVersion) => {
        if (!entity?.id) return;

        let current, key;

        switch (entity.id) {
            case "hardwareVersion":
                current = [...groupingByHarwareVersion];
                key = "groupingByHarwareVersion";
                break;
            case "all":
                current = [...allCameras];
                key = "allCameras";
                break;
            case "entities":
                current = [...groupingSelectedCameras];
                key = "groupingSelectedCameras";
                break;
            default:
                return;
        }

        updateFirmware(current, hardwareVersion, value, key);
    };

    const removeItems = (value) => {
        if (!entity?.id || !value) return;

        const mappings = {
            hardwareVersion: {
                data: [...groupingByHarwareVersion],
                key: "groupingByHarwareVersion"
            },
            all: {
                data: [...allCameras],
                key: "allCameras"
            },
            entities: {
                data: [...groupingSelectedCameras],
                key: "groupingSelectedCameras"
            }
        };

        const { data: current, key } = mappings[entity.id] || {};
        if (current?.length) {
            const indexToRemove = current.findIndex(
                (item) => item?.hardwareVersion === value?.hardwareVersion
            );

            if (indexToRemove > -1) {
                current.splice(indexToRemove, 1);
                dispatch(clearRedux("ASSIGN_FIRMWARE", { [key]: current }));
            }
        }
    };

    const renderFirmwareList = () => {
        let cameras = [];
        if (entity?.id === "all") {
            return <FirmwareList cameras={allCameras} messages={messages} onChange={onChange} removeItems={removeItems} isRestricted={isRestricted} loading={loadingFirmwares} />;
        }
        if (entity?.id === "entities") {
            return <FirmwareList cameras={groupingSelectedCameras} messages={messages} onChange={onChange} removeItems={removeItems} isRestricted={isRestricted} loading={loadingFirmwares} />;
        }
        if (entity?.id === "hardwareVersion") {
            return <FirmwareList cameras={groupingByHarwareVersion} messages={messages} onChange={onChange} removeItems={removeItems} isRestricted={isRestricted} loading={loadingFirmwares} />;
        }
        return null;
    };


    return <div>{renderFirmwareList()}</div>;
}

export default StepTwo